(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["resource-products"] && !Shopify.designMode) return;
  try {
    
  const initializeResourceProducts = (scope = document) => {
    scope.querySelectorAll('[data-resource-products]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      const track = section.querySelector('[data-resource-products-track]');
      const previousButton = section.querySelector('[data-resource-products-prev]');
      const nextButton = section.querySelector('[data-resource-products-next]');
      const firstProduct = section.querySelector('.resource-products__product');

      if (!track || !previousButton || !nextButton || !firstProduct) return;

      const updateButtons = () => {
        const maximumScroll = track.scrollWidth - track.clientWidth;
        previousButton.disabled = track.scrollLeft <= 2;
        nextButton.disabled = track.scrollLeft >= maximumScroll - 2;
      };

      const scrollByProduct = (direction) => {
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        track.scrollBy({
          left: direction * (firstProduct.getBoundingClientRect().width + gap),
          behavior: 'smooth'
        });
      };

      previousButton.addEventListener('click', () => scrollByProduct(-1));
      nextButton.addEventListener('click', () => scrollByProduct(1));
      track.addEventListener('scroll', () => window.requestAnimationFrame(updateButtons), { passive: true });

      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);

      section.dataset.initialized = 'true';
      updateButtons();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeResourceProducts());
  } else {
    initializeResourceProducts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeResourceProducts(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
